import { init, track } from "@amplitude/analytics-node";
import LoggerService from "../../services/logger/logger.service.js";
export const initAmplitudeNode = () => init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY);
export const amplitudeTrackNode = async (userContext, eventName, metadata) => {
    const trackResult = await track(eventName, {
        user: userContext.user,
        meta: metadata,
    }, {
        user_id: userContext.user.email ?? undefined,
    }).promise;
    LoggerService.info("amplify tracking result: ", trackResult);
};
//# sourceMappingURL=amplitude-client.js.map